var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-navigate"},[_c('nav',[_c('ul',_vm._l((_vm.navigation),function(item,i){return _c('li',{key:i,class:{'d-block d-lg-none': item.id == 7 }},[_c('router-link',{class:{'active': _vm.currentUrl === item.slug},attrs:{"to":item.slug}},[_vm._v(_vm._s(item.title))])],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }